import IntObserver from './IntObserver';

export default IntObserver;
